import React from "react";
import type { UserAccount } from "../../api/dev-data/getSessionStatus";

interface AccountItemProps {
    account: UserAccount;
}

const AccountItem: React.FC<AccountItemProps> = ({ account }) => {
    return (
        <div className="flex flex-col">
            <span className="font-semibold">
                {account.accountNickname != null &&
                account.accountNickname !== ""
                    ? account.accountNickname
                    : "Account with Unknown Nickname"}
            </span>
            <span className="text-sm text-slate-600">
                {account.utilityAccountNumber}
            </span>
        </div>
    );
};

export default AccountItem;